import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';

const CDialog = ({ open, onClose, children, className, direction, ...props }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      keepMounted
      className={`CDialog ${className}`}
      {...props}
      // TransitionComponent={React.forwardRef((props, ref) => (
      //  <Slide direction={direction} timeout={1000} ref={ref} {...props} />))} 
        >
        {children}
    </Dialog>
  );
};

export default CDialog;
